import { createUseStyles } from 'react-jss'

export const style = {
  textAreaContainer: {
    padding: '0 15px 15px'
  }
}

export const useStyles = createUseStyles(style)
